/**
 * This className is added to the document body when high contrast emulation is enabled.
 */
export const HighContrastEmulationClassName = 'emulate-hc';

/**
 * Prevents any high contrast styles from being applied to an element or its children.
 */
export const SuppressHighContrastEmulationClassName = 'suppress-hc';

/**
 * Prevents the high contrast background color from being applied to an element or its children.
 */
export const SuppressHighContrastEmulationBGColorClassName = 'suppress-hc-bgcolor';

/**
 * Forces the high contrast background color even when a parent element has suppressed it.
 */
export const ForceHighContrastEmulationClassName = 'hc-force-emulation';

export const HighContrastEmulationColorMap = {
  windowtext: 'white', // Text color
  window: 'black', // Background color
  linktext: '#FFFF00', // Link color
  graytext: '#3FF23F', // Text color for disabled elements (inc. placeholder text)
  buttontext: 'white', // Button text color
  buttonbackground: 'black', // Button background color
  highlighttext: 'black', // Selected text color
  highlight: '#1AEBFF', // Selected background color.
  transparent: 'transparent', // Transparent color
};

interface HighContrastFocusStyles {
  readonly color: string;
  readonly borderColor: string;
  readonly backgroundColor: string;
}

interface HighContrastContextualMenuStylesType {
  readonly list: { readonly selectors: Record<string, { readonly border: string }> };
  readonly subComponentStyles: {
    readonly callout: { readonly selectors: Record<string, { readonly border: string }> };
    readonly menuItem: {
      readonly root: {
        readonly selectors: Record<
          string,
          {
            readonly selectors: Record<string, HighContrastFocusStyles>;
          }
        >;
      };
    };
  };
}

export const HighContrastContextualMenuStyles: HighContrastContextualMenuStylesType = {
  list: {
    selectors: {
      [`.${HighContrastEmulationClassName} &`]: {
        border: `1px solid ${HighContrastEmulationColorMap.windowtext}`,
      },
    },
  },
  subComponentStyles: {
    callout: {
      selectors: {
        [`.${HighContrastEmulationClassName} &`]: {
          border: `1px solid ${HighContrastEmulationColorMap.windowtext}`,
        },
      },
    },
    menuItem: {
      root: {
        selectors: {
          [`.${HighContrastEmulationClassName} &`]: {
            selectors: {
              ':focus *, :focus': {
                color: `${HighContrastEmulationColorMap.highlighttext} !important`,
                borderColor: `${HighContrastEmulationColorMap.highlighttext} !important`,
                backgroundColor: `${HighContrastEmulationColorMap.highlight} !important`,
              },
            },
          },
        },
      },
    },
  },
};
